import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../constants/firebaseModular';
import { NavObject } from '@usacsmideo/types';

export const enableScreen = async ({
  patientId,
  newNavObj,
}: {
  patientId: string;
  newNavObj: NavObject;
}): Promise<string> => {
  const patientRef = doc(db, 'users', patientId);
  return await setDoc(
    patientRef,
    {
      navObj: newNavObj,
    },
    { merge: true },
  )
    .then(() => {
      return 'enabled';
    })
    .catch((error) => {
      console.error('Error enabling screen:', error);
      return 'error';
    });
};
